import { render, staticRenderFns } from "./ReportPayAuthorityModal.vue?vue&type=template&id=d5f3477e&scoped=true&"
import script from "./ReportPayAuthorityModal.vue?vue&type=script&lang=ts&"
export * from "./ReportPayAuthorityModal.vue?vue&type=script&lang=ts&"
import style0 from "./ReportPayAuthorityModal.vue?vue&type=style&index=0&id=d5f3477e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5f3477e",
  null
  
)

export default component.exports